import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Centered, Loader } from '../../components/common';
import { H3, P } from '../../components/common/preflighted';
import { useTheme } from '../../components/common/providers/DialectThemeProvider';
const EncryptionInfo = () => {
    const { textStyles } = useTheme();
    return (_jsxs(Centered, { children: [_jsxs(H3, { className: clsx(textStyles.header, 'dt-flex dt-items-center dt-mb-1'), children: [_jsx(Loader, { className: "dt-mr-2" }), " Waiting for your wallet"] }), _jsx(P, { className: "dt-text-center dt-max-w-sm dt-opacity-50", children: "Please create encryption keys to be able to read and send encrypted messages. It is free and does not involve the network." })] }));
};
export default EncryptionInfo;
//# sourceMappingURL=EncryptionInfo.js.map